import * as React from "react";
import type { SVGProps } from "react";
const SvgUpload04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 25"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.6 16.56v3.6q0 .45-.323.765t-.785.315H3.508q-.462 0-.785-.315a1.03 1.03 0 0 1-.323-.765v-3.6q0-.45.323-.765t.785-.315H7.61c.497 0 .92.331 1.254.698q.169.184.384.337.57.405 1.275.405h2.954q.704 0 1.275-.405.215-.153.384-.337c.335-.367.757-.698 1.254-.698h4.102q.462 0 .785.315t.323.765Zm-3.9-9.53q-.197.45-.681.45h-2.954v5.04a.68.68 0 0 1-.22.506.72.72 0 0 1-.518.214h-2.954a.72.72 0 0 1-.52-.214.68.68 0 0 1-.219-.506V7.48H6.68q-.485 0-.68-.45-.196-.439.161-.776l5.17-5.04A.7.7 0 0 1 11.85 1q.31 0 .519.214l5.17 5.04q.357.338.16.776Z"
    />
  </svg>
);
export default SvgUpload04;
